import React from 'react'
import {useLocation, useHistory} from 'react-router-dom';

const locationMapInverseClass = {
    '/': "home",
    '/flights': "dynamic",
    '/driving':"dynamic",
    '/lodging':"dynamic",
    '/review': "dynamic"
}
function Header({children}) {
    const location = useLocation();

    return (
        <div className={`header ${locationMapInverseClass[location.pathname]}`}>
            {children}
        </div>
    )
}

export default Header